import { toast } from 'react-toastify';

/**
 * Toast Service - Centralized toast notifications
 * Provides consistent toast notifications across the application
 */

const toastConfig = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
};

/**
 * Show success toast
 * @param {string} message - Success message to display
 * @param {object} options - Optional toast configuration overrides
 */
export const showSuccess = (message, options = {}) => {
    toast.success(message, {
        ...toastConfig,
        ...options
    });
};

/**
 * Show error toast
 * @param {string} message - Error message to display
 * @param {object} options - Optional toast configuration overrides
 */
export const showError = (message, options = {}) => {
    toast.error(message, {
        ...toastConfig,
        ...options
    });
};

/**
 * Show info toast
 * @param {string} message - Info message to display
 * @param {object} options - Optional toast configuration overrides
 */
export const showInfo = (message, options = {}) => {
    toast.info(message, {
        ...toastConfig,
        ...options
    });
};

/**
 * Show warning toast
 * @param {string} message - Warning message to display
 * @param {object} options - Optional toast configuration overrides
 */
export const showWarning = (message, options = {}) => {
    toast.warning(message, {
        ...toastConfig,
        ...options
    });
};

/**
 * Show loading toast (promise-based)
 * @param {Promise} promise - Promise to track
 * @param {object} messages - Object with pending, success, error messages
 * @param {object} options - Optional toast configuration overrides
 */
export const showPromise = (promise, messages, options = {}) => {
    toast.promise(
        promise,
        {
            pending: messages.pending || 'Loading...',
            success: messages.success || 'Success!',
            error: messages.error || 'Error occurred'
        },
        {
            ...toastConfig,
            ...options
        }
    );
};

export default {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    showPromise
};
